import React, { useState, lazy, Suspense, useEffect } from 'react';
import {
  FiMap, FiDollarSign, FiCalendar, FiMenu, FiX,
  FiChevronRight, FiLogOut, FiUser, FiList
} from "react-icons/fi";
import TravelManagement from './TravelManagement';
import SalesManagement from './SalesManagement';
import CourseManagement from './CourseManagement';
import styles from './EmployeeDashboard.module.css';
import api from '../api/api';

const ListinManagement = lazy(() => import('./ListinManagement'));

const sections = [
  { key: "routes",  label: "Rutas",   icon: <FiMap size={18} />,      description: "Gestionar rutas de viaje" },
  { key: "courses", label: "Viajes",  icon: <FiCalendar size={18} />, description: "Gestión de viajes programados" },
  { key: "listin",  label: "Listín",  icon: <FiList size={18} />,     description: "Manifiesto y control de abordaje" },
  { key: "sales",   label: "Ventas",  icon: <FiDollarSign size={18} />,description: "Control de ventas" },
];

const EmployeeDashboard = () => {
  const [activeTab, setActiveTab] = useState(
    () => sessionStorage.getItem('employee_tab') || 'routes'
  );
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => { if (e.key === 'Escape') setSidebarOpen(false); };
    const handleResize  = () => { if (window.innerWidth > 900) setSidebarOpen(false); };
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('resize',  handleResize);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('resize',  handleResize);
    };
  }, []);

  const handleSectionClick = (key) => {
    setActiveTab(key);
    sessionStorage.setItem('employee_tab', key);
    setSidebarOpen(false);
  };

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch {
      // Ignorar errores de red
    }
    localStorage.removeItem('currentUser');
    window.location.href = '/';
  };

  const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  const userName = currentUser.user?.name || 'Empleado';
  const userInitial = userName.charAt(0).toUpperCase();

  return (
    <div className={styles.layout}>
      {sidebarOpen && (
        <div className={styles.overlay} onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={`${styles.sidebar} ${sidebarOpen ? styles.sidebarOpen : ''}`}>
        {/* Brand */}
        <div className={styles.brand}>
          <div className={styles.brandLogo}>
            <FiUser size={22} />
          </div>
          <div className={styles.brandInfo}>
            <span className={styles.brandName}>Flamingo</span>
            <span className={styles.brandRole}>Empleado</span>
          </div>
          <button className={styles.closeSidebar} onClick={() => setSidebarOpen(false)}>
            <FiX size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className={styles.sidebarNav}>
          <span className={styles.navSection}>MENÚ PRINCIPAL</span>
          {sections.map((s) => (
            <button
              key={s.key}
              className={`${styles.navItem} ${activeTab === s.key ? styles.navItemActive : ''}`}
              onClick={() => handleSectionClick(s.key)}
            >
              <span className={styles.navIcon}>{s.icon}</span>
              <span className={styles.navLabel}>{s.label}</span>
              {activeTab === s.key && (
                <FiChevronRight size={14} className={styles.navArrow} />
              )}
            </button>
          ))}
        </nav>

        {/* User section at bottom */}
        <div className={styles.sidebarFooter}>
          <div className={styles.userCard}>
            <div className={styles.userAvatar}>{userInitial}</div>
            <div className={styles.userInfo}>
              <span className={styles.userName}>{userName}</span>
              <span className={styles.userRole}>Empleado</span>
            </div>
          </div>
          <button className={styles.logoutBtn} onClick={handleLogout}>
            <FiLogOut size={16} />
            <span>Salir</span>
          </button>
        </div>
      </aside>

      <main className={styles.mainContent}>
        <header className={styles.topBar}>
          <button className={styles.menuToggle} onClick={() => setSidebarOpen(true)}>
            <FiMenu size={22} />
          </button>
          <div className={styles.topBarContent}>
            <h1 className={styles.pageTitle}>
              {sections.find(s => s.key === activeTab)?.label || 'Dashboard'}
            </h1>
            <p className={styles.pageDescription}>
              {sections.find(s => s.key === activeTab)?.description || ''}
            </p>
          </div>
        </header>

        <div className={styles.contentArea}>
          {activeTab === 'routes'  && <TravelManagement />}
          {activeTab === 'courses' && <CourseManagement />}
          {activeTab === 'listin'  && <Suspense fallback={<p style={{padding:'24px',color:'#666'}}>Cargando listín...</p>}><ListinManagement /></Suspense>}
          {activeTab === 'sales'   && <SalesManagement />}
        </div>
      </main>
    </div>
  );
};

export default EmployeeDashboard;
